import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { NgxFileDropEntry, FileSystemFileEntry, NgxFileDropComponent } from 'ngx-file-drop';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ControllerType, HttpClientService } from 'app/services/http-client.service';
import { FileUploadDialogComponent } from 'app/dialogs/file-upload-dialog/file-upload-dialog.component';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.scss'],
})
export class FileuploadComponent implements AfterViewInit {
  public files: NgxFileDropEntry[] = [];
  private fileData: FormData = new FormData();

  @ViewChild(NgxFileDropComponent) fileDropComponent!: NgxFileDropComponent;


  @Input() options: Partial<FileUploadOptions>;

  constructor(
    private httpClient: HttpClientService,
    private modalService: NgbModal,
    private toastService: ToastrService
  ) { }

  ngAfterViewInit(): void {
    const fileInputElement = this.fileDropComponent.fileSelector?.nativeElement as HTMLInputElement;
    if (fileInputElement) {
      fileInputElement.accept = this.options.accept || '*/*';
    }
  }



  public async selectedFiles(files: NgxFileDropEntry[]) {
    // Filter files based on the accept criteria
    const acceptedFiles = await Promise.all(files.map(async file => {
      const fileEntry = file.fileEntry as FileSystemFileEntry;
      const isAccepted = await this.isFileAccepted(fileEntry);
      return isAccepted ? file : null;
    }));

    // Only add files that are not null (i.e., those that passed the acceptance criteria)
    this.files = acceptedFiles.filter(file => file !== null) as NgxFileDropEntry[];
    await this.updateFormData();
  }

  private async isFileAccepted(fileEntry: FileSystemFileEntry): Promise<boolean> {
    const accept = this.options.accept?.split(',').map(ext => ext.trim());
    if (!accept || !accept.length) return true; // Accept all files if no accept options

    return new Promise<boolean>((resolve, reject) => {
      fileEntry.file(file => {
        const fileType = file.name.split('.').pop()?.toLowerCase();
        resolve(accept.includes(`.${fileType}`));
      });
    });
  }

  public removeFile(index: number) {
    this.files.splice(index, 1);
    this.updateFormData().then(() => {
      // Handle any UI updates or further actions after file removal
    });
  }

  private async updateFormData() {
    this.fileData = new FormData();
    const filePromises = this.files.map(file => {
      return new Promise<void>((resolve, reject) => {
        const fileEntry = file.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.fileData.append(file.name, file);
          resolve();
        });
      });
    });

    // Wait for all file entries to be processed before proceeding
    await Promise.all(filePromises);
  }

  public confirmUpload() {
    const modalRef = this.modalService.open(FileUploadDialogComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });

    modalRef.componentInstance.confirm.subscribe(() => {
      this.uploadFiles();
    });
  }

  private uploadFiles() {
    this.httpClient.post({
      controller: this.options.controller,
      action: this.options.action,
      queryString: this.options.queryString,
      headars: new HttpHeaders({ "responseType": "blob" })
    }, this.fileData).subscribe({
      next: (response: any) => {
        this.toastService.success("Seçilen dosya başarılı bir şekilde eklendi.");
        this.files = [];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Seçilen dosya eklenirken bir problem oluştu.");
      },
      complete: () => {
        console.log("complete");
      }
    });
  }
}

export class FileUploadOptions {
  controller?: ControllerType;
  action: string;
  queryString?: string;
  explanation?: string;
  accept?: string;
  isAdminPage?: boolean = false;
}
